import React, { useEffect, useState } from 'react';
import { array, arrayOf, bool, func, shape, string, oneOf, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FormattedMessage, intlShape, useIntl } from '../../util/reactIntl';
import {
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_CLOSED,
  SCHEMA_TYPE_MULTI_ENUM,
  SCHEMA_TYPE_TEXT,
  propTypes,
} from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { convertMoneyToNumber } from '../../util/currency';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import classNames from 'classnames';
import {
  H4,
  Page,
  NamedLink,
  NamedRedirect,
  OrderPanel,
  LayoutSingleColumn,
} from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

import {
  sendInquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
} from './ListingPage.duck';

import {
  LoadingPage,
  ErrorPage,
  priceData,
  listingImages,
  handleContactUser,
  handleSubmitInquiry,
  handleSubmit,
} from './ListingPage.shared';
import ActionBarMaybe from './ActionBarMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionReviews from './SectionReviews';
import SectionAuthorMaybe from './SectionAuthorMaybe';
import SectionMapMaybe from './SectionMapMaybe';
import SectionGallery from './SectionGallery';

import css from './ListingPage.module.css';
import ManualAddress from './ManualAddress';
import Rules from './Rules';
import UpperLocation from './UpperLocation';
import ElectricalAvailability from '../../components/ElectricalAvailability/ElectricalAvailability.js';
import { FaRegHeart } from 'react-icons/fa';
import { FaHeart, FaLocationDot } from 'react-icons/fa6';
import { favouriteListing } from '../SearchPage/SearchPage.duck.js';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api.js';
import moment from 'moment';
import { createResourceLocatorString } from '../../util/routes.js';
const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID, LatLng } = sdkTypes;
const defaultLocation = new LatLng(37.0902, -95.7129);

const toTitleCase = str =>
  str?.replace(/\w\S*/g, word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());





export const ListingPageComponent = props => {
  const [inquiryModalOpen, setInquiryModalOpen] = useState(
    props.inquiryModalOpenForListingId === props.params.id
  );

  const {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    intl,
    onManageDisableScrolling,
    params: rawParams,
    location,
    scrollingDisabled,
    showListingError,
    reviews,
    fetchReviewsError,
    sendInquiryInProgress,
    sendInquiryError,
    monthlyTimeSlots,
    onFetchTimeSlots,
    listingConfig: listingConfigProp,
    onFetchTransactionLineItems,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    history,
    callSetInitialValues,
    onSendInquiry,
    onInitializeCardPaymentData,
    config,

    // author,
    routeConfiguration,
    listingTimeZone,
    onFavouriteListing,
    favListingIds,
    favInProgress,
    forListingWithUrl,
    listingIdFormUrl,
  } = props;
  // prop override makes testing a bit easier
  // TODO: improve this when updating test setup
  // const [customListingIdFromUrl, setCustomListingIdFromUrl] = useState(null);

  // useEffect(() => {
  //   const fetchId = async () => {
  //     if (forListingWithUrl && rawParams?.listingUrl) {
  //       const id = await onFetchListingId(rawParams.listingUrl);
  //       setCustomListingIdFromUrl(id);
  //     }
  //   };

  //   fetchId();
  // }, [forListingWithUrl, rawParams?.listingUrl]);
  const isListingFromCustomUrl = !!rawParams?.listingUrl;
  const isCustomer = currentUser?.attributes?.profile?.publicData?.userType === 'customer';
  const listingConfig = listingConfigProp || config.listing;
  const listingId = !!isListingFromCustomUrl ? listingIdFormUrl : new UUID(rawParams.id);
  const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
  const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
  const currentListing =
    isPendingApprovalVariant || isDraftVariant
      ? ensureOwnListing(getOwnListing(listingId))
      : ensureListing(getListing(listingId));
  const isCreatedWithLink = currentListing.attributes?.publicData?.listingLink;
  const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
  const params = !!isCreatedWithLink
    ? { listingUrl: `@${isCreatedWithLink}` }
    : { slug: listingSlug, ...rawParams };

  const listingPathParamType = isDraftVariant
    ? LISTING_PAGE_PARAM_TYPE_DRAFT
    : LISTING_PAGE_PARAM_TYPE_EDIT;
  const listingTab = isDraftVariant ? 'photos' : 'details';

  const isApproved =
    currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

  const pendingIsApproved = isPendingApprovalVariant && isApproved;

  // If a /pending-approval URL is shared, the UI requires
  // authentication and attempts to fetch the listing from own
  // listings. This will fail with 403 Forbidden if the author is
  // another user. We use this information to try to fetch the
  // public listing.
  const pendingOtherUsersListing =
    (isPendingApprovalVariant || isDraftVariant) &&
    showListingError &&
    showListingError.status === 403;
  const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

  //   useEffect(() => {
  //     if (forListingWithUrl && isCreatedWithLink) {
  //     history.push(
  //       createResourceLocatorString(
  //         'ListingPageWithUrl',
  //         routeConfiguration,
  //         { listingUrl: `@${isCreatedWithLink}` },
  //         {}
  //       )
  //     );
  //   }
  // }, []);

  // useEffect(() => {
  //   try {
  //     const updatedData = {
  //       id: params?.id,
  //     };
  //     const url = `${apiBaseUrl()}/api/updateListing`;
  //     axios.post(url, updatedData);
  //   } catch (error) {
  //     console.error('Error updating count:', error);
  //   }
  // }, []);
  useEffect(() => {
    const updateListing = async () => {
      try {
        if (isListingFromCustomUrl || forListingWithUrl) {
          if (!listingIdFormUrl?.uuid) return;
        }

        const updatedData = {
          id: isListingFromCustomUrl ? listingIdFormUrl.uuid : params?.id,
        };

        const url = `${apiBaseUrl()}/api/updateListing`;
        await axios.post(url, updatedData);
      } catch (error) {
        console.error('Error updating count:', error);
      }
    };

    updateListing();
  }, [forListingWithUrl, listingIdFormUrl?.uuid, params?.id, isListingFromCustomUrl]);

  if (shouldShowPublicListingPage) {
    return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
  }

  const topbar = <TopbarContainer />;

  if (showListingError && showListingError.status === 404) {
    // 404 listing not found
    return <NotFoundPage />;
  } else if (showListingError) {
    // Other error in fetching listing
    return (
      <ErrorPage
        topbar={topbar}
        scrollingDisabled={scrollingDisabled}
        intl={intl}
        fromListingPage={true}
        history={history}
        routeConfiguration={routeConfiguration}
      />
    );
  } else if (!currentListing.id) {
    // Still loading the listing
    return <LoadingPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  }

  const {
    description = '',
    geolocation = null,
    price = null,
    title = '',
    publicData = {},
    metadata = {},
  } = currentListing.attributes;

  const richTitle = (
    <span>
      {richText(title, {
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
        longWordClass: css.longWord,
      })}
    </span>
  );

  const authorAvailable = currentListing && currentListing.author;
  const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
  const isOwnListing =
    userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;

  const currentAuthor = authorAvailable ? currentListing.author : null;
  const ensuredAuthor = ensureUser(currentAuthor);

  // When user is banned or deleted the listing is also deleted.
  // Because listing can be never showed with banned or deleted user we don't have to provide
  // banned or deleted display names for the function
  const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');
  const authorFullName =
    ensuredAuthor?.attributes?.profile?.publicData?.fullName ?? authorDisplayName;

  const { formattedPrice } = priceData(price, config.currency, intl);

  const commonParams = { params, history, routes: routeConfiguration };
  const onContactUser = handleContactUser({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    location,
    setInitialValues,
    setInquiryModalOpen,
  });
  // Note: this is for inquiry state in booking and purchase processes. Inquiry process is handled through handleSubmit.
  const onSubmitInquiry = handleSubmitInquiry({
    ...commonParams,
    getListing,
    onSendInquiry,
    setInquiryModalOpen,
  });
  const onSubmit = handleSubmit({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    getListing,
    onInitializeCardPaymentData,
    forListingWithUrl,
    listingIdFormUrl,
    isCreatedWithLink,
  });

  const handleOrderSubmit = values => {
    const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
    if (isOwnListing || isCurrentlyClosed) {
      window.scrollTo(0, 0);
    } else {
      onSubmit(values);
    }
  };
  // const facebookImages = listingImages(currentListing, 'facebook'); 
  const facebookImages = listingImages(currentListing, 'default');  
  const twitterImages = listingImages(currentListing, 'twitter');
  const schemaImages = listingImages(
    currentListing,
    // `${config.layout.listingImage.variantPrefix}-2x`
    'default'
  ).map(img => img.url);
  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage(
    { id: 'ListingPage.schemaTitle' },
    { title, price: formattedPrice, marketplaceName }
  );
  // const schemaTitleForThumbNail = `${authorFullName} | Coworking day pass on Adventurely`;

  // You could add reviews, sku, etc. into page schema
  // Read more about product schema
  // https://developers.google.com/search/docs/advanced/structured-data/product
  const productURL = `${config.marketplaceRootURL}${location.pathname}${location.search}${location.hash}`;
  const schemaPriceMaybe = price
    ? {
        price: intl.formatNumber(convertMoneyToNumber(price), {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        priceCurrency: price.currency,
      }
    : {};
  const currentStock = currentListing.currentStock?.attributes?.quantity || 0;
  const schemaAvailability =
    currentStock > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock';

  const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

  const handleFav = e => {
    e.preventDefault();
    if (favInProgress) {
      return null;
    } else {
      const body = {
        listingId: currentListing.id.uuid,
        // authorId: currentListing.author.id.uuid,
        // currentUserId: currentUser?.id?.uuid,
        active: currentListing?.attributes?.state === 'published' ? true : false,
      };

      onFavouriteListing(body);
    }
  };
  const businessname = ensuredAuthor?.attributes?.profile?.publicData?.businessName;
  const { listingType, unitType, availableStartTime, availableEndTime } = publicData || {
    availableStartTime: { label: {} },
    availableEndTime: { label: {} },
  };
  const { label: startTimeLabel } = availableStartTime || {};
  const { label: endTimeLabel } = availableEndTime || {};
  const duration = moment.duration(
    moment(publicData.availableEndTime?.label, 'h:mm A').diff(
      moment(publicData.availableStartTime?.label, 'h:mm A')
    )
  );
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const timeDifference = minutes === 0 ? `${hours} hours` : `${hours} hours ${minutes} minutes`;
  const thumbnailBusinessName = toTitleCase(businessname);
  const schemaTitleForThumbNail = intl.formatMessage(
    { id: 'Thumbnail.schemaTitleForThumNail' },
    { customThumbnailName: thumbnailBusinessName }
  );
 
   return (
     <Page
       title={schemaTitle}
       className={css.ListingPageWrap}
       scrollingDisabled={scrollingDisabled}
       author={authorDisplayName}
       // description={description}
       description={' '}
       facebookImages={facebookImages}
       twitterImages={twitterImages}
       socialSharing={{
         title: schemaTitleForThumbNail,
       }}
       schema={{
         '@context': 'http://schema.org',
         '@type': 'Product',
         description: description,
         name: schemaTitle,
         image: schemaImages,
         offers: {
           '@type': 'Offer',
           url: productURL,
           ...schemaPriceMaybe,
           availability: schemaAvailability,
         },
       }}
     >
       <LayoutSingleColumn
         className={classNames(css.pageRoot, css.ListingpageMain)}
         topbar={topbar}
         footer={<FooterContainer />}
       >
         <div className={css.contentWrapperForProductLayout}>
           <div className={css.mainColumnForProductLayout}>
             {currentListing.id ? (
               <ActionBarMaybe
                 className={css.actionBarForProductLayout}
                 isOwnListing={isOwnListing}
                 listing={currentListing}
                 editParams={{
                   id: listingId.uuid,
                   slug: listingSlug,
                   type: listingPathParamType,
                   tab: listingTab,
                 }}
               />
             ) : null}
             {isAuthenticated ? (
               <div className={css.locationAndFavDiv}>
                 <UpperLocation currentListing={currentListing} publicData={publicData} />
                 {!isOwnListing && isCustomer && (
                   <button type="button" className={css.favbtn} onClick={handleFav}>
                     {favListingIds?.includes(currentListing.id.uuid) ? (
                       <FaHeart />
                     ) : (
                       <FaRegHeart />
                     )}
                   </button>
                 )}
               </div>
             ) : (
               <div className={css.locationAndFavDiv}>
                 <UpperLocation currentListing={currentListing} publicData={publicData} />

                 <NamedLink name="LoginPage">
                   <button type="button" className={css.favbtn}>
                     {favListingIds?.includes(currentListing.id.uuid) ? (
                       <FaHeart />
                     ) : (
                       <FaRegHeart />
                     )}
                   </button>
                 </NamedLink>
                 {/* <button type="button" className={css.favbtn}>
                  <FaRegHeart />
                </button> */}
               </div>
             )}

             <SectionGallery
               listing={currentListing}
               variantPrefix={config.layout.listingImage.variantPrefix}
               onManageDisableScrolling={onManageDisableScrolling}
             />
             <div className={css.mobileHeading}>
               <H4 as="h1" className={css.orderPanelTitle}>
                 <FormattedMessage id="ListingPage.orderTitle" values={{ title: richTitle }} />
               </H4>
             </div>
             {/* <div className={css.mobilebookingMessage}>Book a Remote Work Day Pass Here</div> */}
             <div className={css.mobilebookingMessage}>Book a Coworking Day Pass</div>
             <div className={css.mobilelocationDIV}>
               <span className={css.pinIcon}>
                 <FaLocationDot />
               </span>
               <p className={css.businessName}>{`Work from ${businessname}`}</p>
             </div>
             {startTimeLabel && endTimeLabel && (
               <div className={css.MobiledurationMainDiv}>
                 <span className={css.clockIcon}>
                   <i className="fa-regular fa-clock"></i>
                 </span>

                 {/* <span className={css.timeDuration}>Duration: </span> */}
                 <span className={css.timeDurationHours}>{timeDifference}, </span>

                 <span
                   className={css.timeDuration}
                 >{`${publicData.availableStartTime?.label} - ${publicData.availableEndTime?.label}`}</span>
               </div>
             )}

             <div className={css.mobileIncludesDiv}>
               {title && <div className={css.IncludesDiv}>includes {title.split('+')[1]}</div>}
             </div>

             <SectionTextMaybe text={description} showAsIngress />
             {/* <SectionDetailsMaybe
              publicData={publicData}
              metadata={metadata}
              listingConfig={listingConfig}
              intl={intl}
            /> */}
             {listingConfig.listingFields.reduce((pickedElements, config) => {
               const { key, enumOptions, scope = 'public' } = config;
               const value =
                 scope === 'public' ? publicData[key] : scope === 'metadata' ? metadata[key] : null;
               const hasValue = value !== null;
               return hasValue && config.schemaType === SCHEMA_TYPE_MULTI_ENUM
                 ? [
                     ...pickedElements,
                     <SectionMultiEnumMaybe
                       key={key}
                       heading={config?.showConfig?.label}
                       options={createFilterOptions(enumOptions)}
                       selectedOptions={value}
                     />,
                   ]
                 : hasValue && config.schemaType === SCHEMA_TYPE_TEXT
                 ? [
                     ...pickedElements,
                     <SectionTextMaybe
                       key={key}
                       heading={config?.showConfig?.label}
                       text={value}
                     />,
                   ]
                 : pickedElements;
             }, [])}
             {/* {publicData?.manualAddress && (
              <ManualAddress publicData={publicData} listingId={currentListing.id} />
            )} */}

             <ElectricalAvailability
               publicDataElectric={publicData.electricalOutletOption}
               heading={'Electrical outlet availability'}
             />

             <SectionMapMaybe
               geolocation={geolocation}
               publicData={publicData}
               listingId={currentListing.id}
               mapsConfig={config.maps}
             />
             {publicData.rulesValOption &&
               !Object.values(publicData.rulesValOption).every(value => value === false) && (
                 <Rules publicData={publicData} />
               )}

             <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} />
             <SectionAuthorMaybe
               title={title}
               listing={currentListing}
               authorDisplayName={authorDisplayName}
               onContactUser={onContactUser}
               isInquiryModalOpen={isAuthenticated && inquiryModalOpen}
               onCloseInquiryModal={() => setInquiryModalOpen(false)}
               sendInquiryError={sendInquiryError}
               sendInquiryInProgress={sendInquiryInProgress}
               onSubmitInquiry={onSubmitInquiry}
               currentUser={currentUser}
               onManageDisableScrolling={onManageDisableScrolling}
             />
           </div>
           <div className={css.orderColumnForProductLayout}>
             <OrderPanel
               currentListingName={title}
               className={css.productOrderPanel}
               listing={currentListing}
               isOwnListing={isOwnListing}
               onSubmit={handleOrderSubmit}
               authorLink={
                 <NamedLink
                   className={css.authorNameLink}
                   name="ListingPage"
                   params={params}
                   to={{ hash: '#author' }}
                 >
                   {authorDisplayName}
                 </NamedLink>
               }
               title={
                 <FormattedMessage id="ListingPage.orderTitle" values={{ title: richTitle }} />
               }
               titleDesktop={
                 <H4 as="h1" className={css.orderPanelTitle}>
                   <FormattedMessage id="ListingPage.orderTitle" values={{ title: richTitle }} />
                 </H4>
               }
               author={ensuredAuthor}
               onManageDisableScrolling={onManageDisableScrolling}
               onContactUser={onContactUser}
               monthlyTimeSlots={monthlyTimeSlots}
               onFetchTimeSlots={onFetchTimeSlots}
               onFetchTransactionLineItems={onFetchTransactionLineItems}
               lineItems={lineItems}
               fetchLineItemsInProgress={fetchLineItemsInProgress}
               fetchLineItemsError={fetchLineItemsError}
               validListingTypes={config.listing.listingTypes}
               marketplaceCurrency={config.currency}
               dayCountAvailableForBooking={config.stripe.dayCountAvailableForBooking}
               marketplaceName={config.marketplaceName}
               listingTimeZone={listingTimeZone}
               currentUser={currentUser}
             />
           </div>
         </div>
       </LayoutSingleColumn>
     </Page>
   );
};

ListingPageComponent.defaultProps = {
  currentUser: null,
  inquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: null,
  sendInquiryError: null,
  listingConfig: null,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from useHistory
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // from useLocation
  location: shape({
    search: string,
  }).isRequired,

  // from useIntl
  intl: intlShape.isRequired,

  // from useConfiguration
  config: object.isRequired,
  // from useRouteConfiguration
  routeConfiguration: arrayOf(propTypes.route).isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  inquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  monthlyTimeSlots: object,
  // monthlyTimeSlots could be something like:
  // monthlyTimeSlots: {
  //   '2019-11': {
  //     timeSlots: [],
  //     fetchTimeSlotsInProgress: false,
  //     fetchTimeSlotsError: null,
  //   }
  // }
  sendInquiryInProgress: bool.isRequired,
  sendInquiryError: propTypes.error,
  onSendInquiry: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  listingConfig: object,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const EnhancedListingPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  return (
    <ListingPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { favInProgress } = state.SearchPage;
  const { favListingIds } = state.SearchPage;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendInquiryInProgress,
    sendInquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    inquiryModalOpenForListingId,
    listingTimeZone,
    listingIdFormUrl,
  } = state.ListingPage;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    favInProgress,
    favListingIds,
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    inquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendInquiryInProgress,
    sendInquiryError,
    listingTimeZone,
    listingIdFormUrl,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onSendInquiry: (listing, message) => dispatch(sendInquiry(listing, message)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  onFavouriteListing: data => dispatch(favouriteListing(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(connect(mapStateToProps, mapDispatchToProps))(EnhancedListingPage);

export default ListingPage;
